import { Box, useTheme } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import OrdersCard from "../../../../components/global/cards/orders/OrdersCard";
import ShLabel from "../../../../components/theme/label/ShLabel";
import ShLabelSkeleton from "../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../components/theme/skeleton/ShTextSkeleton";
import Text from "../../../../components/theme/text/Text";
import { useExportOrdersMutation, useGetOrdersQuery } from "../../../../newapi/order/ordersSlice";
import { tokens } from "../../../../theme";

import { useSelector } from "react-redux";
import ShDataGrid3 from "../../../../components/theme/datagrid3/ShDataGrid3";
import { RELATION_ORDERS_FAMILY } from "../family";
import ShCopyButton from '../../../../components/theme/ShCopy';
import SidepanelLoader from "../../../../components/theme/sidepanel2/SidepanelLoader";
import { getOrderStateData } from "../../../../utils/labelColorText";
import { ORDER_FILTER_KEYS } from "../../../../components/global/DataGrid/Filter";
import { general_states } from "../../../../utils/staticEnums";
import AddIcon from '@mui/icons-material/Add';
import ButtonGroup from "../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../components/theme/buttons/Shbutton";
import { selectUserPermission } from "../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from '../../../../utils/permissions';
import MpAddOrder from "../../../../components/global/ModalsProgression/MpAddOrder/MpAddOrder";
import MpAddOrderRelation from "../../../../components/global/ModalsProgression/MpAddOrderRelation/MpAddOrderRelation";
import { showToastPromise } from "../../../../utils/toasts";
import { DownloadOutlined } from "@mui/icons-material";
import ShDataGrid2 from "../../../../components/theme/datagrid2/ShDataGrid2";
import { RELATION_ORDERS_DEFAULT } from "../../../../components/theme/datagrid3/groupingPresets/GroupingPresets";
import SHQuickAction from "../../../../components/theme/Modal/SHQuickAction";
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
import OrderShipmentsStatusLabel from "../../../../components/global/Sidepanels/SpOrderDetails/components/OrderShipmentsStatusLabel";
const SpOrderDetails = SidepanelLoader(() => import("../../../../components/global/Sidepanels/SpOrderDetails/SpOrderDetails"));

const GridActions = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    return props.hasCreatePermission ?
        <ButtonGroup version={2}>
            <Shbutton
                className={"group-btn"}
                color={theme.palette.mode === "dark" ? "primaryGrey" : "grey"}
                onClick={() => props.exportOrders()}
                endIcon={<DownloadOutlined/>}
                variant="contained"
                isLoading={props.isExporting}
            >
                {t("export")}
            </Shbutton>
            <Shbutton 
                className={"group-btn"} 
                color={theme.palette.mode === "dark" ? "blue" : "primary"} 
                onClick={() => props.handleOpen(true)}
                endIcon={<AddIcon/>}
                variant="contained"
            >
                {t('new_order')}
            </Shbutton>
        </ButtonGroup> : <></>
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
    filter: [ORDER_FILTER_KEYS.PRODUCT, ORDER_FILTER_KEYS.B2B_ORDERS, ORDER_FILTER_KEYS.WEBSHOP],

};

const OutboundShippedView = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [data, setData] = useState([]);
    
    const [config, setConfig] = useState({
        [ORDER_FILTER_KEYS.STATE.backend_key]:[general_states.SHIPPED],
        "relationId": useSelector((state) => state.settings.environment.selectedId)
    });

    const hasCreatePermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.RP_ORDER_MANAGE])
    );
    
    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }

    const handleOpen = () => {
        setAddModalOpen(true);
    }

    const [defaultTab, setDefaultTab] = useState(null);
    const handleClose = (response) => {
        setAddModalOpen(false);
        const newOrderState = response?.data?.state ?? response?.state;
        const newOrderId = response?.data?.id ?? response?.id;
        if (newOrderState === general_states.ACTION_REQUIRED_CUSTOMER && newOrderId) {
            if (!spLoading) setSpLoading(true);
            setOrderId(newOrderId);
            orderIdRef.current = newOrderId;
            setDefaultTab(2);
            setIsExtended(true);
        }
    };
    
    const [isExtended, setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
            mobileActions: <GridActions isExporting={isExporting}  
            hasCreatePermission={hasCreatePermission} 
            handleOpen={handleOpen} 
            exportProducts={exportOrdersCall}></GridActions>,
        });

        return () => {
            
        }
    },[]);

    const [filter, setFilter] = useState({"state":["shipped"]});
        const [exportOrders, {isLoading: isExporting}] = useExportOrdersMutation();
        const exportOrdersCall = async () => {  
            const exportPromise = exportOrders(filter).unwrap();
    
            showToastPromise(
                exportPromise,
                t,
                {
                    pending: t('export_processing') || 'Processing export...',
                    success: t('export_success') || 'Export completed successfully',
                    error: t('export_failed') || 'Export failed'
                }
            ).then((result) => {
                if (result.processing) {
                    console.log('Export is being processed in background. Export ID:', result.exportId);
                }
            }).catch((error) => {
                console.error("Export failed", error);
            });
        }

    const [orderId, setOrderId] = useState();
    const orderIdRef = useRef(orderId);
    
    const getOrderDetails = (params) => {
        if (!params) return;
    
        const neworderId = parseInt(params.row.id);
        // Only update state if the orderId has actually changed
        if (orderIdRef.current !== neworderId) {
            
            if(!spLoading) {
                setSpLoading(true);
            }
            setOrderId(neworderId);
            orderIdRef.current = neworderId; // Update the ref to the new value
        }
        setDefaultTab(null);
        setIsExtended(true);
    };


    const columns = [
        {
            field: "barcode",
            headerName: t('order'),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (
                    <Box sx={{
                        minWidth:"100%",
                        height:"100%",
                        display:"flex",
                        alignItems:"center",
                        position:"relative",
                        whiteSpace:"nowrap",
                        wordBreak:"keep-all",
                        textOverflow:"ellipsis",
                        overflow:"hidden",
                        ".copyel": {
                            opacity:0,
                        },
                        "&:hover .copyel": {
                            opacity:1,
                        }
                    }}>
                        <Box
                            sx={{
                                minWidth:"100%",
                                height:"100%",
                                display:"flex",
                                alignItems:"center",
                                position:"relative",
                                whiteSpace:"nowrap",
                                wordBreak:"keep-all",
                                textOverflow:"ellipsis",
                                overflow:"hidden",
                                gap:2,

                            }}
                        >
                            <Text noBreak>{params.row.barcode}</Text>
                            {params.row.remark &&
                                <SHQuickAction
                                    disableScrollLock={true}
                                    component={
                                        <Box
                                            sx={{
                                                px:1.5,
                                                display:"flex",
                                                flexDirection:"column"
                                            }}
                                        >
                                            <Text light>{t("remark")}</Text>
                                            <Text>{params.row.remark}</Text>
                                        </Box>
                                    }
                                >
                                    {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
                                        <Box
                                            aria-owns={anchorEl ? 'simple-popover' : undefined}
                                            aria-haspopup={false}
                                            onMouseEnter={onMouseEnter}
                                            onMouseLeave={onMouseLeave}
                                            onTouchStart={onTouchStart}
                                            sx={{
                                                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                                                height:32,
                                                width:32,
                                                color: colors.txt['secondary'],
                                                display:'flex',
                                                alignItems:'center',
                                                justifyContent:'center',
                                                borderRadius:4,
                                            }}
                                        >
                                            <CommentOutlinedIcon fontSize='small'/>
                                        </Box>
                                    )}
                                </SHQuickAction>
                            }
                        </Box>
                        <ShCopyButton 
                            styles={{button:{
                                background:theme.palette.mode === "dark" ? colors.grey[600] :  colors.grey[200],
                                color: colors.txt["primary"],
                                "&:hover" : {
                                    background:theme.palette.mode === "dark" ? colors.grey[500] :colors.grey[300],

                                }
                            }}} 
                            sx={{position:"absolute",right:0,zIndex:3000}} 
                            className={"copyel"} 
                            closeAfter={1500} 
                            value={params.row.barcode}
                        ></ShCopyButton>
                    </Box>
                );
            }
        },
        {field: "deliveryName", headerName: t("name"),flex:1, 
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.deliveryName
            }
        },
        {field: "webshopreference", headerName: t("webshopreference"),flex:2,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (<Text>{`${params.row.webshopcredentials?.description ?? t("self_created")} - ${params.row.webshopreference} (${params.row.deliveryCountry ? params.row.deliveryCountry.toUpperCase() : ""})`}</Text>)
            }
        },
        {field: "deliveryMethod", headerName: t("delivery_method"),flex:1, sortable:false,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
               return t(params.row.deliveryMethod);
            }
        },
        {field: "orderlinesCount", headerName: t("orderlines_count"),flex:1, sortable: false,
        renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }
            return params.row.amountOfLines
        }},
        // {field: "shipper", headerName: t("shipper_name"),flex:1,
        // renderCell: (params) => {
        //     if(params.row.skeleton) {
        //         return <ShTextSkeleton/>
        //     }
        //     return params.row.shipper?.name
        // }},
        {
            field: "date_sent", 
            headerName: t("date_sent"),
            flex:1,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {

                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                let labelcolor = "green";
               // let planned = new Date(params.row.date_planned);
                let sent = params.row.date_sent ? new Date(params.row.date_sent) : null;
                
                // if(sent) {
                //     // when sent is filled and is equal to planned: green
                //     if(sent.toDateString() === planned.toDateString() || sent.getTime() <= planned.getTime()) {
                //         labelcolor = "green";
                //     }
                //     // when sent is filled but later than planned: orange
                //     else if(sent.getTime() > planned.getTime()) {
                //         labelcolor = "orange";
                //     }
                // }

                return (
                    <ShLabel size={32} fitted variant={labelcolor} palette="normal">
                        {sent ? sent.toLocaleDateString(i18n.language) : ""}
                    </ShLabel>
                );
            }
        },
        {
            field: "state", 
            headerName: t("state"),
            flex:1,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                const { labelcolor, labeltext } = getOrderStateData(params.row.state, theme);
              
                return (
                    <ShLabel size={32} palette="normal" variant={labelcolor}>
                      {t(labeltext)}
                    </ShLabel>
                  );
              }
        },
        {
            field: "shipmentStatus",
            headerName: t("shipment_status"),
            flex:1,
            sortable:false,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                return <OrderShipmentsStatusLabel shipments={params.row.shipments} />
            }
        },
        {
            field: "createdAt",
            headerName: t("date_created"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                const date = new Date(params.row.createdAt);
                const dateStr = date.toLocaleDateString(i18n.language, { dateStyle: 'short' });
                const timeStr = date.toLocaleTimeString(i18n.language, { timeStyle: 'short' });

                return (
                    <Text>
                        {dateStr}{' '}<Text light>{timeStr}</Text>
                    </Text>
                );
            },
            grouping: RELATION_ORDERS_DEFAULT.CREATED_AT,
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <OrdersCard onClick={() => getOrderDetails(params)} skeleton={params.row.skeleton ?? false} {...params.row}  />
                )
            }
        }
    ];
    

    return (
        <Box height={1} display={"flex"} flexDirection={"column"}>
            {/* <GridActions></GridActions> */}
            <ShDataGrid3 key={theme.palette.mode}
                gridKey={RELATION_ORDERS_FAMILY.SHIPPED.gridKey}
                family={RELATION_ORDERS_FAMILY}
                pollingInterval={true}
                content={useGetOrdersQuery}
                config={config}
                gridActions={<GridActions  isExporting={isExporting} hasCreatePermission={hasCreatePermission} handleOpen={handleOpen} exportOrders={exportOrdersCall}></GridActions>}
                filterObjectChanged={(filterObject) => {
                    setFilter(filterObject?.filter);
                }}
                title={t('shipped') }
                gridOptions={gridOptions}
                enableGrouping={true}
                sortModel={{field: columns[5].field,type:"DESC"}}
                sort={{field: columns[5].field,type:"DESC"}}
                columns={columns}
                onRowClick={getOrderDetails}>
            </ShDataGrid3>

            {spLoading &&
                <SpOrderDetails
                    defaultTab={defaultTab}
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    orderId={orderId}
                    relation={true}
                    canReserveOrderLines={true}
                />
            }
            <MpAddOrderRelation onOpen={() => addModal.setOpen(true)} onClose={() => addModal.setOpen(false)} open={addModal.open} handleClose={handleClose} />
        </Box>
    );
}


export default OutboundShippedView;